import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequirementService } from 'src/app/services/requirement.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-delete-note',
    templateUrl: './delete-note.component.html',
    styleUrls: ['./delete-note.component.scss'],
    standalone: false
})
export class DeleteNoteComponent implements OnInit {
	@Output() deleteFile = new EventEmitter<boolean>();
	@Input () idFile: number;
	@Input () title: string;
	@Input () path: string;
	@Input () message: number = -1;
	loading: boolean = false;
  constructor(
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
	) { }

  ngOnInit() {
  }
	confirmDelete(event) {
		if (event) {
			this.loading = true;
			this._requirements.deleteNote(this.idFile, this.path).subscribe((resp) => {
				if (resp['error']) {
					this.loading = false;
					this.message = 0;
				} else {
					this.message = 1;
					this.loading = false;
					setTimeout(() => this.activeModal.dismiss(), 2000);
					setTimeout(() => this.deleteFile.emit(true), 2000);
				}
			});
		}
	}
}
